import React, { useEffect, useState } from 'react';
import RoundCloseButton from 'images/round-close-button.png';
import { Col, Modal, ModalProps, Row } from 'antd';
import Style from './ModalOtp.module.scss';
import Text from 'Pages/Home/Components/Atoms/Text/Text';
import Spacer from 'Pages/Home/Components/Atoms/Spacer/Spacer';
import { useFormik } from 'formik';
import useTimer from '../../Hooks/useTimer';
import {
  TSendOtpResponseData,
  TVerifyOtpPayload,
} from '../../Hooks/useRegisterWithOTP';
import { toast } from 'react-toastify';
import InputNumberAntd from 'Reuseables/InputNumberAntd';
import { useHistory } from 'react-router';
import { connect } from 'react-redux';
import { doFetchProfile } from 'actions/authAction';
import AppDisplay from 'images/footer-phone-display.png';
import DownloadOnPlayStore from 'images/download-on-playstore.png';
import DownloadOnAppStore from 'images/download-on-appstore.png';
import KickImage from 'Reuseables/KickImage';

interface IFormikValues {
  emailOtp: string;
  phoneNumberOtp: string;
}

type TSendOtp = () => Promise<{
  isSuccess: boolean;
  message: string;
  data: TSendOtpResponseData | null;
}>;

type TSubmitVerifyOtp = (payload: TVerifyOtpPayload) => Promise<{
  isSuccess: boolean;
  message: string;
  data: {
    sms_code: string;
    email: string;
    email_code: string;
    mobile_number: string;
    updated_at: string;
    created_at: string;
    id: number;
  } | null;
  detail?: {
    sms_code: Array<string>;
    email_code: Array<string>;
  };
}>;

interface IModalOtpProps extends ModalProps {
  email: string;
  phoneNumber: string;
  password: string;
  phoneCountryCode?: string;
  isPosting?: boolean;
  sendOtpEmail: TSendOtp;
  sendOtpPhoneNumber: TSendOtp;
  submitVerifyOtp: TSubmitVerifyOtp;
}

const ModalOtp: React.FC<IModalOtpProps> = (props) => {
  const {
    email,
    phoneNumber,
    password,
    phoneCountryCode,
    isPosting,
    onCancel,
    sendOtpEmail,
    sendOtpPhoneNumber,
    submitVerifyOtp,
    doFetchProfile,
    ...modalProps
  } = props as IModalOtpProps & { doFetchProfile: () => any };

  const history = useHistory();
  const [isRegistered, setIsRegistered] = useState<boolean>(false);
  const emailOtpTimer = useTimer({
    timeInSecond: 60,
    pause: true,
  });
  const phoneNumberOtpTimer = useTimer({
    timeInSecond: 60,
    pause: true,
  });

  const form = useFormik<IFormikValues>({
    initialValues: {
      emailOtp: '',
      phoneNumberOtp: '',
    },
    onSubmit: async (values) => {
      if (isPosting) {
        return;
      }
      setIsRegistered(false);

      const response = await submitVerifyOtp({
        email_code: values.emailOtp,
        sms_code: values.phoneNumberOtp,
        email,
        password,
      });

      if (!response.isSuccess) {
        if (response?.detail?.email_code) {
          form.setFieldError('emailOtp', 'Please enter the correct OTP');
        }

        if (response?.detail?.sms_code) {
          form.setFieldError('phoneNumberOtp', 'Please enter the correct OTP');
        }

        // errorToast(response.message);
        return;
      }

      doFetchProfile().then(() => {
        setIsRegistered(true);
      });
    },
  });

  const { emailOtp, phoneNumberOtp } = form.values;
  const { emailOtp: errorEmailOtp, phoneNumberOtp: errorPhoneNumberOtp } =
    form.errors;
  const setValue = form.setFieldValue;
  const isDisabledSubmit = !emailOtp || !phoneNumberOtp;

  const errorToast = (message: string) => {
    toast.error(message, {
      position: 'top-right',
      autoClose: 5000,
      closeOnClick: true,
      pauseOnHover: true,
    });
  };

  const resendEmail = () => {
    if (emailOtpTimer.isLoading) {
      return;
    }
    sendOtp('email');
  };

  const resendPhoneNumber = () => {
    if (phoneNumberOtpTimer.isLoading) {
      return;
    }
    sendOtp('phoneNumber');
  };

  const sendOtp = async (type: 'email' | 'phoneNumber' | 'all') => {
    const res = { resOtpEmail: null, resOtpPhoneNumber: null };

    if (type === 'email') {
      emailOtpTimer.setIsLoading(true);
      const resOtpEmail = await sendOtpEmail();
      if (!resOtpEmail.isSuccess) {
        errorToast(resOtpEmail.message);
      }

      emailOtpTimer.setIsLoading(false);
      emailOtpTimer.exec();

      Object.assign(res, { resOtpEmail });
      return res;
    }

    if (type === 'phoneNumber') {
      phoneNumberOtpTimer.setIsLoading(true);
      const resOtpPhoneNumber = await sendOtpPhoneNumber();
      if (!resOtpPhoneNumber.isSuccess) {
        errorToast(resOtpPhoneNumber.message);
      }

      phoneNumberOtpTimer.setIsLoading(false);
      phoneNumberOtpTimer.exec();

      Object.assign(res, { resOtpPhoneNumber });
      return res;
    }

    if (type === 'all') {
      emailOtpTimer.setIsLoading(true);
      phoneNumberOtpTimer.setIsLoading(true);
      const [resOtpEmail, resOtpPhoneNumber] = await Promise.all([
        sendOtpEmail(),
        sendOtpPhoneNumber(),
      ]);

      if (!resOtpEmail.isSuccess) {
        errorToast(resOtpEmail.message);
      } else {
        emailOtpTimer.setIsLoading(false);
        emailOtpTimer.exec();
      }

      if (!resOtpPhoneNumber.isSuccess) {
        errorToast(resOtpPhoneNumber.message);
      } else {
        phoneNumberOtpTimer.setIsLoading(false);
        phoneNumberOtpTimer.exec();
      }

      Object.assign(res, { resOtpEmail, resOtpPhoneNumber });
    }

    return res;
  };

  const openPlayStore = () => {
    window.open(
      'https://play.google.com/store/apps/details?id=com.kickavenue.androidshop&hl=in',
      '_blank',
    );
  };

  const openAppStore = () => {
    window.open(
      'https://apps.apple.com/id/app/kickavenue-shop-collectibles/id1478394222',
      '_blank',
    );
  };

  const closeModal = (e) => {
    if (!isRegistered) {
      if (onCancel) {
        onCancel(e);
      }
      return;
    }

    if (onCancel) {
      onCancel(e);
    }

    history.replace('/');

    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  useEffect(() => {
    sendOtp('all');
    return () => {
      setIsRegistered(false);
    };
  }, []);

  return (
    <Modal
      {...modalProps}
      className={Style['modal-otp']}
      closable={false}
      centered
      footer={null}
      width={isRegistered ? 'auto' : undefined}
    >
      <img
        onClick={closeModal}
        className={Style['close-btn']}
        src={RoundCloseButton}
        alt="close-btn"
      />
      {isRegistered && (
        <div className={Style['registered']}>
          <Row>
            <Col xs={24} md={24} lg={12}>
              <KickImage
                src={AppDisplay}
                alt="Kickavenue apps display"
                className={Style['apps-display-image']}
              />
            </Col>
            <Col xs={24} md={24} lg={12}>
              <Row align={'middle'} style={{ height: '100%' }}>
                <div className={Style['content-container']}>
                  <Row>
                    <h1 className={Style['hi-text']}>
                      Hi, Welcome to{' '}
                      <span className={Style['green-text']}>Kick Avenue</span>
                    </h1>
                  </Row>
                  <Spacer height={16} />
                  <Row>
                    <p className={Style['desc-text']}>
                      Thousands of authentic sneakers, streetwear, luxury and
                      <br />
                      lifestyle items in the palm of your hand. What are you
                      waiting for?
                      <br />
                      Immerse yourself in the latest trend in fashion.
                    </p>
                  </Row>
                  <Spacer height={12} />
                  <Row gutter={[16, 0]} align={'middle'}>
                    <Col span={12}>
                      <KickImage
                        src={DownloadOnPlayStore}
                        alt="Download on Playstore"
                        className={Style['download-apps-image']}
                        onClick={openPlayStore}
                      />
                    </Col>
                    <Col span={12}>
                      <KickImage
                        src={DownloadOnAppStore}
                        alt="Download on Appstore"
                        className={Style['download-apps-image']}
                        onClick={openAppStore}
                      />
                    </Col>
                  </Row>
                </div>
              </Row>
            </Col>
          </Row>
        </div>
      )}

      {!isRegistered && (
        <div className={Style['content']}>
          <Row>
            <Col span={24}>
              <Text className={Style['text-title']}>OTP Verification</Text>
            </Col>
          </Row>
          <Spacer height={12} />
          <Row>
            <Col span={24}>
              <Text className={Style['text-sub-title']}>
                Please enter the 6-digit verification code.
              </Text>
            </Col>
          </Row>
          <Spacer height={16} />

          <Row>
            <Col span={24}>
              <InputNumberAntd
                className={Style[errorEmailOtp ? 'input-error' : 'input']}
                placeholder="Enter Email Verification Code"
                value={emailOtp}
                onChange={(e) => {
                  setValue('emailOtp', e.target.value);
                }}
                suffix={
                  <div className={Style['suffix']}>
                    {emailOtpTimer.isTimeout && (
                      <Text
                        className={
                          Style[
                            emailOtpTimer.isLoading ? 'text-disabled' : 'text'
                          ]
                        }
                        onClick={resendEmail}
                      >
                        {emailOtpTimer.isLoading ? 'Sending...' : 'Resend'}
                      </Text>
                    )}

                    {!emailOtpTimer.isTimeout && (
                      <Text className={Style['text-disabled']}>
                        Resend in <b>{emailOtpTimer.time}s</b>
                      </Text>
                    )}
                  </div>
                }
              />
            </Col>
          </Row>
          <Spacer height={6} />
          <Row>
            <Col span={24}>
              {errorEmailOtp && (
                <Text className={Style['text-error']}>
                  Please enter the correct OTP
                </Text>
              )}

              {!errorEmailOtp && (
                <Text className={Style['text-info']}>
                  Code sent to <b>{email}</b>
                </Text>
              )}
            </Col>
          </Row>
          <Spacer height={12} />

          <Row>
            <Col span={24}>
              <InputNumberAntd
                className={Style[errorPhoneNumberOtp ? 'input-error' : 'input']}
                placeholder="Enter Phone Verification Code"
                value={phoneNumberOtp}
                onChange={(e) => {
                  setValue('phoneNumberOtp', e.target.value);
                }}
                suffix={
                  <div className={Style['suffix']}>
                    {phoneNumberOtpTimer.isTimeout && (
                      <Text
                        className={
                          Style[
                            phoneNumberOtpTimer.isLoading
                              ? 'text-disabled'
                              : 'text'
                          ]
                        }
                        onClick={resendPhoneNumber}
                      >
                        {phoneNumberOtpTimer.isLoading
                          ? 'Sending...'
                          : 'Resend'}
                      </Text>
                    )}

                    {!phoneNumberOtpTimer.isTimeout && (
                      <Text className={Style['text-disabled']}>
                        Resend in <b>{phoneNumberOtpTimer.time}s</b>
                      </Text>
                    )}
                  </div>
                }
              />
            </Col>
          </Row>
          <Spacer height={6} />
          <Row>
            <Col span={24}>
              {errorPhoneNumberOtp && (
                <Text className={Style['text-error']}>
                  Please enter the correct OTP
                </Text>
              )}

              {!errorPhoneNumberOtp && (
                <Text className={Style['text-info']}>
                  Code sent to <b>{`${phoneCountryCode}${phoneNumber}`}</b>
                </Text>
              )}
            </Col>
          </Row>
          <Spacer height={16} />

          <Row>
            <Col span={24}>
              <button
                className={Style['button']}
                disabled={isDisabledSubmit}
                onClick={form.submitForm}
              >
                <Text className={Style['text']}>
                  {isPosting ? 'Submitting' : 'Submit'}
                </Text>
              </button>
            </Col>
          </Row>
        </div>
      )}
    </Modal>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  doFetchProfile: () => dispatch(doFetchProfile()),
});

export default connect(null, mapDispatchToProps)(ModalOtp);
